import CalculPage from "../pages/CalculPage";
import CalculsParametersPage from "../pages/CalculsParametersPage";

const routes = [
  {
    path: "/calculs",
    exact: true,
    element: CalculPage,
  },
  {
    path: "/calculs/parameters",
    exact: true,
    element: CalculsParametersPage,
  },
];

export default routes;
